export default {"src":"/_next/static/media/logo1.5b44803a.svg","height":34,"width":180};